import { Box } from "@chakra-ui/react";

import { InfinityBanner } from "../components/InfinityBanner";
import { Footer } from "../components/Footer";
import { ClientHero } from "../components/ClientHero";
import { FindProfessionals } from "../components/FindProfessionals";
import { Features } from "../components/Features";
import { FAQs } from "../components/FAQs";

export const Client = () => {
  return (
    <Box>
      <ClientHero />

      <FindProfessionals />

      <InfinityBanner />

      <Features />

      <FAQs />

      <Footer />
    </Box>
  );
};
